import React, { useState } from 'react';
import ReactTooltip from 'react-tooltip';
import { Modal } from 'react-bootstrap';
import { SellerProfile } from '../admin-dashboard-tables/interfaces';
import AccountsSVG from '../admin-dashboard-tables/assets/AccountsSVG';
import useResize from '../../../utils/hooks/useResize';
import ProfilesSubTable from '../admin-dashboard-tables/ProfilesSubTable';
import { getComputedCSSVariable } from '../../../utils/cssVariableHelpers';

interface Props {
  accountID: string,
  profiles: Array<SellerProfile>,
  seller_profiles_count: number,
}

const ProfilesTooltip:React.FC<Props> = ({
  accountID,
  profiles,
  seller_profiles_count,
}) => {
  const [showModal, setShowModal] = useState(false);
  const dimensions = useResize();

  if (dimensions?.width && dimensions?.width < 768) {
    return (
      <>
        <a
          className="profiles btn btn-admin-button-gray d-flex align-items-center justify-content-center p-0"
          href="#"
          onClick={(e) => {
            e.preventDefault();
            setShowModal(true);
          }}
        >
          <AccountsSVG />
          <span className="num">{seller_profiles_count || 0}</span>
        </a>
        <Modal
          className="profiles-modal"
          show={showModal}
          onHide={() => setShowModal(false)}
          scrollable
          centered
        >
          <ProfilesSubTable
            accountID={accountID}
            profiles={profiles}
            totalProfilesCount={seller_profiles_count}
          />
        </Modal>
      </>
    );
  }

  return (
    <>
      <a
        data-tip
        className="profiles btn btn-admin-button-gray d-flex align-items-center justify-content-center p-0"
        data-place="right"
        data-for={`${accountID}`}
      >
        <AccountsSVG />
        <span className="num">{seller_profiles_count || 0}</span>
      </a>
      <ReactTooltip
        id={`${accountID}`}
        aria-haspopup={true}
        place="right"
        delayHide={500}
        effect="solid"
        type="success"
        backgroundColor="white"
        border={true}
        borderColor={getComputedCSSVariable('primary')}
        className="hover-tool-tip-profiles border-blue-400"
      >
        <ProfilesSubTable
          accountID={accountID}
          profiles={profiles}
          totalProfilesCount={seller_profiles_count}
        />
      </ReactTooltip>
    </>
  );
};

export default ProfilesTooltip;
